import React, { Component } from "react";


class ContainerLeft extends Component {
  render() {
    return (
      <div
        className="col-left animate-element wow delay5 fadeInDown"
        data-wow-delay="0.5s"
      >
        <div className="flat-title t1">
          <h4 className="sub-title mb-2">This is my passion</h4>
          <h2 className="title-section color-d12 mg-b34">
            My Projects
          </h2>
      
        </div>
    
      </div>
      
    );
  }
}

export default ContainerLeft;
